import React from 'react';

import { Link } from 'react-router-dom';

// Modal

// Icons
import { MdAccountBalance, MdOutlineArrowRightAlt } from 'react-icons/md';
import { IoHardwareChipOutline } from 'react-icons/io5';
import { GiShipBow, GiGears } from 'react-icons/gi';
import { AiFillControl } from 'react-icons/ai';
import { SiSpeedtest } from 'react-icons/si';

function WorkWithUs() {
  return (
    <section className="relative bg-center bg-no-repeat bg-cover bg-[url()]">
      <div class="absolute inset-0 bg-white md:bg-transparent md:bg-gradient-to-r sm:from-white sm:via-white/75 sm:to-transparent"></div>

      <div className="container relative max-w-screen-xl px-10 py-16 mx-auto md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-y-8 lg:gap-x-16 lg:items-start">
          <div className="block gap-4 mx-auto text-center lg:text-left lg:mx-0 md:flex md:items-center">
            <div className="basis-4/6">
              <h2 className="text-3xl font-bold sm:text-4xl">We are hiring!</h2>

              <p className="mt-4 text-gray-600">
                Are you a person ready to get involved? This is the company for
                you! We have job openings, click on the job description that's
                right for you and send us your application now.
              </p>
            </div>
            <div className="basis-2/6">
              <Link
                className="inline-flex items-center py-4 mt-8 text-white transition-all bg-blue-600 border border-blue-600 rounded px-9 hover:bg-transparent hover:text-blue-600 active:text-blue-500 focus:outline-none focus:ring"
                to="/careers"
              >
                <span className="text-sm font-medium">
                  Show me open positions
                </span>
                <MdOutlineArrowRightAlt className="w-5 h-5 ml-3" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WorkWithUs;
